import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Divider', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      borderColor: `${cyan[500]}18 !important`,
      position: 'relative' as const,

      [`&${componentCls}-horizontal`]: {
        '&:after': {
          content: '""',
          position: 'absolute',
          top: -0.5,
          left: '20%',
          right: '20%',
          height: 1,
          background: `linear-gradient(90deg, transparent, ${cyan[500]}40, transparent)`,
          pointerEvents: 'none',
        },
      },

      [`${componentCls}-inner-text`]: {
        color: `${cyan[600]} !important`,
        fontSize: '11px',
        textTransform: 'uppercase' as const,
        letterSpacing: '1px',
      },
    },
  }
})
